import { LOGIN_PATH, MICROSOFT_LOGIN_PATH } from '../lib/api';
import { ActionButton, ActionStack } from '../components/common';

// The three ways in, drawn once.
//
// Both customer doors show them — the one a registration link opens (`c1b`) and
// the sign-in page an old link now lands on (flow 1.6) — and a second copy is
// how one of them would quietly end up offering two providers while the other
// offered three.

function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M21.8 12.2c0-.7-.1-1.4-.2-2H12v3.9h5.5c-.2 1.3-1 2.3-2 3v2.5h3.3c1.9-1.8 3-4.4 3-7.4z" />
      <path fill="#34A853" d="M12 21.6c2.7 0 5-.9 6.6-2.4l-3.3-2.5c-.9.6-2 1-3.3 1-2.6 0-4.8-1.7-5.5-4.1H3.1v2.6c1.7 3.2 5 5.4 8.9 5.4z" />
      <path fill="#FBBC05" d="M6.5 13.6c-.2-.6-.3-1.2-.3-1.8s.1-1.2.3-1.8V7.4H3.1C2.4 8.8 2 10.3 2 12s.4 3.2 1.1 4.6l3.4-2.6z" />
      <path fill="#EA4335" d="M12 6.3c1.5 0 2.8.5 3.8 1.5l2.9-2.9C17 3.3 14.7 2.4 12 2.4c-3.9 0-7.2 2.2-8.9 5.4l3.4 2.6c.7-2.4 2.9-4.1 5.5-4.1z" />
    </svg>
  );
}

function AppleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M16.4 12.9c0-2.4 2-3.6 2.1-3.7-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1 1-4 2.4-1.7 3-.4 7.3 1.2 9.7.8 1.2 1.8 2.5 3.1 2.4 1.2 0 1.7-.8 3.2-.8s1.9.8 3.2.8 2.2-1.2 3-2.4c.9-1.4 1.3-2.7 1.4-2.8-.1 0-2.8-1-2.8-3.8zM14 5.7c.7-.8 1.1-1.9 1-3-1 0-2.1.7-2.8 1.5-.6.7-1.2 1.8-1 2.9 1.1.1 2.2-.6 2.8-1.4z" />
    </svg>
  );
}

function MicrosoftMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="3" width="8.5" height="8.5" fill="#F25022" />
      <rect x="12.5" y="3" width="8.5" height="8.5" fill="#7FBA00" />
      <rect x="3" y="12.5" width="8.5" height="8.5" fill="#00A4EF" />
      <rect x="12.5" y="12.5" width="8.5" height="8.5" fill="#FFB900" />
    </svg>
  );
}

// THE CUSTOMER'S DOOR SAYS SO. The login handler marks the browser, and the
// callback refuses a stranger on the customer's own page (`/signin?refused=`)
// rather than the desk's `/denied` (customer-sign-in-registration AC36). The
// desk's sign-in buttons carry no mark and are untouched.
const FROM_CUSTOMER = '?from=customer';

/**
 * Google, Apple, Microsoft — in the order the prototype draws them.
 *
 * APPLE IS DRAWN AND NOT WIRED. Row 3's AC40 says what ships when the Apple
 * Services ID, key and redirect are not configured at `build it` — and they
 * were not: the button stays drawn and disabled with the reason stated on the
 * page, and `apple-sign-in` is its own chore. A button that bounces a customer
 * through a provider and lands them nowhere is how a person decides the whole
 * app is broken.
 */
export function ProviderButtons() {
  return (
    <ActionStack>
      <ActionButton href={LOGIN_PATH + FROM_CUSTOMER} icon={<GoogleMark />}>
        Continue with Google
      </ActionButton>
      <ActionButton disabled title="Apple sign-in is coming" icon={<AppleMark />}>
        Continue with Apple
      </ActionButton>
      <ActionButton href={MICROSOFT_LOGIN_PATH + FROM_CUSTOMER} icon={<MicrosoftMark />}>
        Continue with Microsoft
      </ActionButton>
    </ActionStack>
  );
}
